var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.getData.codigo == 10
      ? _c("div", [
          _c("b", [_vm._v("Glosa SII: ")]),
          _vm._v(" " + _vm._s(_vm.getData.glosaSii) + " ")
        ])
      : _c("div", { staticStyle: { color: "red" } }, [
          _vm._v(" No fue posible obtener la información. ")
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }